import { render } from "./tpl_search.vue?vue&type=template&id=061d38b9&scoped=true"
import script from "./tpl_search.vue?vue&type=script&lang=js"
export * from "./tpl_search.vue?vue&type=script&lang=js"

import "./tpl_search.vue?vue&type=style&index=0&id=061d38b9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061d38b9"],['__file',"src/views/wap/template/tpl_search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "061d38b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('061d38b9', __exports__)) {
    console.log('reload')
    api.reload('061d38b9', __exports__)
  }
  
  module.hot.accept("./tpl_search.vue?vue&type=template&id=061d38b9&scoped=true", () => {
    console.log('re-render')
    api.rerender('061d38b9', render)
  })

}


export default __exports__